import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import API from "../config/axios";
import { api_paths } from "../config/api.paths";

const IMG_PATH = process.env.REACT_APP_IMAGE_BASEURL || "";

const Sponsors = () => {
  const [loading, setLoading] = useState(false);
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    const fetchSponsers = async () => {
      setLoading(true);
      try {
        const response = await API.get(
          `${api_paths.member.SPONSORS.GET_SPONSORS}/?pagination=false`
        );
        // console.log("sponsors List:", response.data);

        const data = response.data?.payload?.data || [];
        setSponsors(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching events:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSponsers();
  }, []);

  return (
    <Container className="py-5">
      <Row className="mb-4">
        <Col lg={12}>
          <div className="rsvp-header text-center">
            <h1 className="inter-bold h1">Sponsors</h1>
            <p>Constitution and Membership</p>
          </div>
        </Col>
      </Row>

      <Row>
        {sponsors.length > 0 &&
          sponsors.map((sponsor) => (
            <Col
              key={sponsor._id}
              xs={6}
              sm={4}
              md={3}
              lg={2}
              className="my-2 d-flex justify-content-center"
            >
              <div className="sponsor-wrapper">
                {sponsor?.logo_path ? (
                  sponsor?.website_link ? (
                    <a
                      href={sponsor.website_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={`${IMG_PATH}${sponsor.logo_path}`}
                        alt={sponsor?.name}
                        className="sponsor-img"
                      />
                    </a>
                  ) : (
                    <img
                      src={`${IMG_PATH}${sponsor.logo_path}`}
                      alt={sponsor?.name}
                      className="sponsor-img"
                    />
                  )
                ) : (
                  <div
                    style={{
                      width: "100px",
                      height: "100px",
                      border: "1px solid #ccc",
                    }}
                  />
                )}
              </div>
            </Col>
          ))}
      </Row>
    </Container>
  );
};

export default Sponsors;
